import React, { FC } from 'react';
import { Alert, Button } from '@clearcover/atlas';
import { useAuth0 } from 'Auth';
import { UserType } from 'Admin/Users/types';
import styles from './styles.module.css';

export const UserActivation: FC<{
  user: UserType;
  handleClick: (activated: boolean) => () => void;
}> = ({ user, handleClick }) => {
  const { user: currentUser } = useAuth0();

  return (
    <div>
      {currentUser && currentUser.id !== user.id ? (
        !user.activated ? (
          <Alert
            message="Users will be granted access to the portal. User Details will enable but can be deactivated."
            title="Activate User"
            type="light-brand"
            className={styles.alert}
            action={
              <Button
                link
                variant="primary"
                size="sm"
                onClick={handleClick(true)}
                className={styles.action}
              >
                Activate
              </Button>
            }
          />
        ) : (
          <Alert
            message="Users will lose access to the portal. User Details will appear disabled but can be reactivated. "
            title="Deactivate User"
            type="light-error"
            className={styles.alert}
            action={
              <Button
                link
                variant="danger"
                size="sm"
                onClick={handleClick(false)}
                className={styles.action}
              >
                Deactivate
              </Button>
            }
          />
        )
      ) : null}
    </div>
  );
};
